"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselKeen = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("keen-slider/react");
const react_2 = require("react");
const plugins = __importStar(require("./plugins"));
const styles_1 = require("./styles");
const getDefaultSlides = (options) => {
    var _a, _b;
    return typeof (options === null || options === void 0 ? void 0 : options.slides) === 'object' &&
        typeof ((_a = options === null || options === void 0 ? void 0 : options.slides) === null || _a === void 0 ? void 0 : _a.perView) === 'number'
        ? (_b = options === null || options === void 0 ? void 0 : options.slides) === null || _b === void 0 ? void 0 : _b.perView
        : 3;
};
function Wrap({ children, enhance: Enhance, next, previous, goToIndex, }) {
    return Enhance ? ((0, jsx_runtime_1.jsx)(Enhance, Object.assign({ next: next, previous: previous, goToIndex: goToIndex }, { children: children }))) : (children);
}
function CarouselKeen({ options, data, render, enhance, hideArrows, plugins: customPlugins, }) {
    const [loaded, setLoaded] = (0, react_2.useState)(false);
    const perView = getDefaultSlides(options);
    const animationDisabled = data.length <= perView;
    const [sliderRef, instanceRef] = (0, react_1.useKeenSlider)(Object.assign({ initial: 0, slides: {
            perView,
        }, defaultAnimation: {
            duration: 1500,
            easing: (v) => -(Math.cos(Math.PI * v) - 1) / 2,
        }, loop: !animationDisabled, created() {
            setLoaded(true);
        } }, options), [
        ...(customPlugins !== null && customPlugins !== void 0 ? customPlugins : []),
        (slider) => {
            let timeout;
            let mouseOver = false;
            function clearNextTimeout() {
                clearTimeout(timeout);
            }
            function nextTimeout() {
                var _a;
                clearTimeout(timeout);
                if (mouseOver) {
                    return;
                }
                if (slider.slides.length > 0 && !(options === null || options === void 0 ? void 0 : options.noAutoSwitch)) {
                    timeout = setTimeout(() => {
                        slider.next();
                    }, (_a = options === null || options === void 0 ? void 0 : options.autoSwitchTimeout) !== null && _a !== void 0 ? _a : 5000);
                }
            }
            slider.on('created', () => {
                slider.container.addEventListener('mouseover', () => {
                    mouseOver = true;
                    clearNextTimeout();
                });
                slider.container.addEventListener('mouseout', () => {
                    mouseOver = false;
                    nextTimeout();
                });
                nextTimeout();
            });
            slider.on('dragStarted', clearNextTimeout);
            slider.on('animationEnded', nextTimeout);
            slider.on('updated', nextTimeout);
        },
    ]);
    const displayArrows = loaded && instanceRef.current && !animationDisabled;
    const handleChange = (0, react_2.useCallback)((direction) => (e) => {
        var _a, _b, _c;
        e.stopPropagation();
        if (instanceRef.current && !((_a = instanceRef.current) === null || _a === void 0 ? void 0 : _a.animator.active)) {
            if (direction === 'left') {
                (_b = instanceRef.current) === null || _b === void 0 ? void 0 : _b.prev();
            }
            else {
                (_c = instanceRef.current) === null || _c === void 0 ? void 0 : _c.next();
            }
        }
    }, [instanceRef]);
    const goToIndex = (0, react_2.useCallback)((idx) => {
        var _a, _b;
        if (instanceRef.current && !((_a = instanceRef.current) === null || _a === void 0 ? void 0 : _a.animator.active)) {
            (_b = instanceRef.current) === null || _b === void 0 ? void 0 : _b.moveToIdx(idx);
        }
    }, [instanceRef]);
    return ((0, jsx_runtime_1.jsx)(Wrap, Object.assign({ enhance: enhance, next: handleChange('right'), previous: handleChange('left'), goToIndex: goToIndex }, { children: (0, jsx_runtime_1.jsxs)(styles_1.Navigation, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ ref: sliderRef, className: "keen-slider" }, { children: data.map((singleData, index) => ((0, jsx_runtime_1.jsx)(styles_1.Slide, Object.assign({ className: "keen-slider__slide" }, { children: render(singleData, index) }), index))) })), displayArrows && !hideArrows && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Arrow, { left: true, onClick: handleChange('left') }), (0, jsx_runtime_1.jsx)(Arrow, { onClick: handleChange('right') })] }))] }) })));
}
exports.CarouselKeen = CarouselKeen;
function Arrow({ left, onClick, }) {
    return (0, jsx_runtime_1.jsx)(styles_1.ArrowComp, { "$direction": left ? 'left' : 'right', onClick: onClick });
}
CarouselKeen.plugins = plugins;
